import {
  formatDateTime,
  getDateRange,
  getTimeSinceDate,
} from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import { CalendarIcon, LocationIcon } from '@airship-platform/jam-web/icons';
import Typography from '@mui/material/Typography';
import React, { PropsWithChildren } from 'react';

interface ScheduleCardAppointment {
  startDateTime: string;
  endDateTime?: string;
}

interface ScheduleCardCustomer {
  name: string;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
}

interface ScheduleCardProps {
  appointment: ScheduleCardAppointment;
  customer: ScheduleCardCustomer;
  subHeaderContent?: React.ReactNode;
  cardAction: React.ReactNode;
}

const formatDisplayDate = (appointment: ScheduleCardAppointment) =>
  appointment.endDateTime
    ? getDateRange(appointment.startDateTime, appointment.endDateTime)
    : [
        formatDateTime(appointment.startDateTime),
        `(${getTimeSinceDate(
          new Date().toISOString(),
          appointment.startDateTime
        )})`,
      ].join(' ');

const ScheduleCard: React.FC<PropsWithChildren<ScheduleCardProps>> = ({
  appointment,
  customer,
  subHeaderContent,
  cardAction,
  children,
}) => (
  <FlexBox
    flexDirection={['column', 'row']}
    alignItems={['left', 'center']}
    justifyContent={'space-between'}
    gap={2}
  >
    <FlexBox display={'flex'} flexDirection={'column'} gap={1}>
      <Typography variant="h4">{customer.name}</Typography>

      {subHeaderContent}

      <FlexBox flexDirection={'column'} gap={0.5}>
        <FlexBox alignItems={'flex-start'} gap={1}>
          <CalendarIcon />
          <Typography variant="body2">
            {formatDisplayDate(appointment)}
          </Typography>
        </FlexBox>

        <FlexBox alignItems={'flex-start'} gap={1}>
          <LocationIcon />
          <Typography variant="body2">
            {customer.address} {customer.city}, {customer.state} {customer.zip}
          </Typography>
        </FlexBox>

        {children}
      </FlexBox>
    </FlexBox>
    {cardAction}
  </FlexBox>
);

export default ScheduleCard;
